<div class="row emoji-selector space-between">
    <div *ngFor="let type of emojiTypes; let i = index" (click)="selectEmoji(i + 1)" [class.selected]="emojiSelected.value === i + 1">
        <app-icon size="50" [type]="type" [color]="getEmojiColorByType(type)"></app-icon>
    </div>
</div>